import "../css/vehicle.css";
import Logo from "../assets/infraLogo.jpg"
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";


const API_BASE =
  import.meta.env?.VITE_API_BASE ||
  process.env.REACT_APP_API_BASE ||
  "https://rfs2.infraconsoft.net.in/api";

const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");


const SupplierPrint = () => {
    const { sCode } = useParams();
  const [subDetails, setSubDetails] = useState({});
  const [formData, setFormData] = useState({
    price: "",
    disc: "",
    pf: "",
    gst: ""
  });

        const [site, setSite] = useState({
    ok: true,
    name: "Infraconsoft",
    logo: null,
    address: "",
    email: "",
    phone: "",
    _ts: 0,
  });

  // Fetch site/company info
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const res = await axios.get(`${API_BASE}/siteinfo`);
        const s = res?.data || {};
        // ensure absolute logo URL if server ever returns relative
        let logo = s.logo || null;
        if (logo && !/^https?:\/\//i.test(logo)) {
          if (!logo.startsWith("/")) logo = `/${logo}`;
          logo = `${API_ORIGIN}${logo}`;
        }
        if (!ignore) {
          setSite({
            ok: !!s.ok,
            name: s.name || "Infraconsoft",
            logo,
            address: s.address || "",
            email: s.email || "",
            phone: s.phone || "",
            _ts: Date.now(),
          });
        }
      } catch (e) {
        // keep defaults on failure
        console.error("Failed to load /siteinfo", e);
      }
    })();
    return () => {
      ignore = true;
    };
  }, []);


  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/supplierMaster_fetchSubData?sCode=${sCode}`);
        const items = response.data.modifySupplier;
  
        if (items.length > 0) {
          const item = items[0];
          const storeReqHeader1 = {
            sName: item.supplierMaster_name,
            address1: item.supplierMaster_addressline1,
            address2: item.supplierMaster_addressline2,
            city: item.supplierMaster_city,
            pinCode: item.supplierMaster_pincode,
            phone: item.supplierMaster_phoneNumber,
            email: item.supplierMaster_email,
            fax: item.supplierMaster_faxNumber,
            pan: item.supplierMaster_webSite,
            gst: item.supplierMaster_taxpercentage,
            rcNo: item.supplierMaster_rcNumber,
            rcDate: item.supplierMaster_rcDate,
            gstNo: item.supplierMaster_cstNumber,
            gstDate: item.supplierMaster_cstDate,
            disc: item.supplierMaster_DiscountPercentage,
            taxType: item.supplierMaster_taxtype,
            payment: item.supplierMaster_paymentMethod,
            delivery: item.supplierMaster_deliveryMethod,
            pf: item.supplierMaster_PFPercentage,
            insurance: item.supplierMaster_insuranceMethod,
            supplierMaster: item.supplierMaster_type,
            ecc: item.supplierMaster_eccNumber,
            remarks: item.supplierMaster_remarks,
          };
  
          setSubDetails(storeReqHeader1);
          setFormData({
            sName: storeReqHeader1.sName,
            address1: storeReqHeader1.address1,
            address2: storeReqHeader1.address2,
            city: storeReqHeader1.city,
            pinCode: storeReqHeader1.pinCode,
            phone: storeReqHeader1.phone,
            email: storeReqHeader1.email,
            gst: storeReqHeader1.gst,
            fax: storeReqHeader1.fax,
            pan: storeReqHeader1.pan,
            rcNo: storeReqHeader1.rcNo,
            rcDate: storeReqHeader1.rcDate,
            gstNo: storeReqHeader1.gstNo,
            gstDate: storeReqHeader1.gstDate,
            disc: storeReqHeader1.disc,
            taxType: storeReqHeader1.taxType,
            payment: storeReqHeader1.payment,
            delivery: storeReqHeader1.delivery,
            pf: storeReqHeader1.pf,
            insurance: storeReqHeader1.insurance,
            supplierMaster: storeReqHeader1.supplierMaster,
            ecc: storeReqHeader1.ecc,
            remarks: storeReqHeader1.remarks,
          });
        }
      } catch (error) {
        console.error("Error fetching supplier details:", error);
      }
    };
  
    fetchSupplierDetails();
}, [sCode]);

const logoSrc = site.logo ? `${site.logo}${site._ts ? `?v=${site._ts}` : ""}` : Logo;

  return (
    <div className="supplierPrint-container">
      <div className="prPrint-header">
        <img src={logoSrc} alt={`${site.name} Logo`} className="prPrint-logo" />
        <div className="prPrint-company-details">
          <h2 style={{ textTransform: "uppercase" }}>{site.name || "Infraconsoft"}</h2>
          {site.address && <p>{site.address}</p>}
          {(site.phone || site.email) && (
            <p>
              {site.phone && <span>Ph: {site.phone}</span>}
              {site.phone && site.email && <span> | </span>}
              {site.email && <span>Email: {site.email}</span>}
            </p>
          )}
        </div>
      </div>

      <table className="supplierPrint-table">
        <tbody>
          <tr>
            <td><b>Name:</b></td> <td>{formData.sName}</td>
            <td><b>Supplier Code:</b></td> <td>{sCode}</td>
          </tr>
          <tr>
            <td><b>Address 1:</b></td> <td>{formData.address1}</td>
            <td><b>Address 2:</b></td> <td>{formData.address2}</td>
          </tr>
          <tr>
            <td><b>City:</b></td> <td>{formData.city}</td>
            <td><b>Pincode:</b></td> <td>{formData.pinCode}</td>
          </tr>
          <tr>
            <td><b>Phone Number:</b></td> <td>{formData.phone}</td>
            <td><b>Email:</b></td> <td>{formData.email}</td>
          </tr>
          <tr>
            <td><b>Fax:</b></td> <td>{formData.fax}</td>
            <td><b>PAN:</b></td> <td>{formData.pan}</td>
          </tr>
          <tr>
            <td><b>RC Number:</b></td> <td>{formData.rcNo}</td>
            <td><b>RC Date:</b></td> <td>{formData.rcDate ? new Date(formData.rcDate).toLocaleDateString("en-GB"): ""}</td>
            
          </tr>
          <tr>
            <td><b>GST Number:</b></td> <td>{formData.gstNo}</td>
            <td><b>GST Date:</b></td> <td>{formData.gstDate ? new Date(formData.gstDate).toLocaleDateString("en-GB"): ""}</td>
          </tr>
          <tr>
            <td><b>Tax Percentage:</b></td> <td>{formData.gst}</td>
            <td><b>Discount %:</b></td> <td>{formData.disc}</td>
          </tr>
          <tr>
            <td><b>Supplier Type:</b></td> <td>{formData.supplierMaster}</td>
            <td><b>PF %:</b></td> <td>{formData.pf}</td>
          </tr>
          <tr>
            <td><b>Payment:</b></td> <td>{formData.payment}</td>
            <td><b>Delivery:</b></td> <td>{formData.delivery}</td>
          </tr>
          <tr>
            <td><b>ECC Number:</b></td> <td>{formData.ecc}</td>
            <td><b>Insurance:</b></td> <td>{formData.insurance}</td>
          </tr>
          <tr>
            <td><b>Remarks:</b></td> <td>{formData.remarks}</td>
          </tr>
        </tbody>
      </table>
      
      <div className="inward-print">
        <button onClick={() => window.print()}>🖨️ Print</button>
      </div>
    </div>
  );
};

export default SupplierPrint;
